import React, { useState, useRef, useEffect } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import ReactImageMagnify from 'react-image-magnify'
import classNames from 'classnames'
import defaultImg from 'app/assets/images/default.png'
import styles from './index.module.less'

interface DetailImgProps {
  imgList?: Array<string | undefined>
}

export default function DetailImg({ imgList = [] }: DetailImgProps) {
  const [activation, setActivation] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)
  /**当前位置*/
  const [scrollIndex, setScrollIndex] = useState(0)
  /**滚动宽度 */
  const [scrollWidth, setScrollWidth] = useState(0)
  /**滚动次数 */
  const [scrollLength, setScrollLength] = useState(0)

  const swapperRef = useRef<number>(0)
  const contentRef = useRef<any>()
  const contentWidth = useRef<any>()

  const onLeft = () => {
    if (scrollIndex + 1 === scrollLength) return

    setScrollIndex(scrollIndex + 1)
    setScrollLeft(scrollLeft + swapperRef.current * -1)
  }

  const onRight = () => {
    if (!scrollIndex) return

    setScrollIndex(scrollIndex - 1)
    setScrollLeft(scrollLeft + swapperRef.current)
  }

  useEffect(() => {
    const contentWidth = contentRef.current.clientWidth
    const scrollWidth = imgList.length * (49 + 12) - 12

    swapperRef.current = contentWidth
    setScrollLength(Math.ceil(scrollWidth / contentWidth))
    setScrollWidth(scrollWidth)
  }, [imgList])

  return (
    <div className={styles.detailImg}>
      <div className={styles.bigImg}>
        <ReactImageMagnify
          className={styles.reactImageMagnify}
          smallImage={{
            isFluidWidth: true,
            src: imgList?.[activation] || defaultImg,
          }}
          largeImage={{
            src: imgList?.[activation] || defaultImg,
            width: 500,
            height: 1000,
          }}
        />
      </div>
      <div className={styles.smallImgList} ref={contentWidth}>
        {scrollLength > 1 && (
          <LeftOutlined
            className={classNames(
              styles.icon,
              styles.iconLeft,
              scrollIndex + 1 === scrollLength && styles.disabled
            )}
            onClick={onLeft}
          />
        )}

        <div className={styles.listScroll} ref={contentRef}>
          <div
            style={{
              width: scrollWidth + 'px',
              left: scrollLeft,
            }}
          >
            {imgList?.map((item, index) => (
              <div
                className={`${styles.smallImg} ${
                  activation === index && styles.smallImgActivation
                }`}
                key={index}
                onMouseMove={() => setActivation(index)}
              >
                <img src={item || defaultImg} alt="" />
              </div>
            ))}
          </div>
        </div>
        {scrollLength > 1 && (
          <RightOutlined
            className={classNames(
              styles.icon,
              styles.iconRight,
              !scrollIndex && styles.disabled
            )}
            onClick={onRight}
          />
        )}
      </div>
    </div>
  )
}
